/* eslint-disable  */
import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Stack,
  SvgIcon,
  Modal,
} from "@mui/material";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import PlusIcon from "@heroicons/react/24/solid/PlusIcon";
// import axios from "axios";
import Box from "@mui/material/Box";
import {
  get,
  tempget,
  temppost,
  tempremove,
  post,
  remove,
} from "../library/Api";
import { ToastContainer, toast } from "react-toastify";
// import { post } from "../library/Api";
import Tooltip from "@mui/material/Tooltip";
// import { makeStyles } from '@mui/styles';
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import PulseLoader from "react-spinners/PulseLoader";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "../assets/images/warning.svg";
import UserExistCheckModal from "../commonComponents/Modals/UserExistCheckModal";

const RegisterForms = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [company, setCompany] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [account, setAccount] = useState("");
  const [vehicle, setVehicle] = useState("0");
  const [profile, setProfile] = useState("");
  const [rfid, setRfid] = useState("");
  const [regdate, setRegdate] = useState("");
  const [emailError, setEmailError] = useState("");
  const [nameErr, setFirstNameErr] = useState(false);
  const [building, setBuilding] = useState("250 Assay Street");
  const [garage, setGarage] = useState("707 Redemption");
  // { label: "Admin", value: "Admin"}
  const [accessGroup, setAccessGroup] = useState([]);
  const [facilityCode, setfacilityCode] = useState("");
  const [optionSelected, setOptionselected] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [company_Id_ForPassing, setCompanyId_ForPassing] = useState(null);
  const [companyname, setCompanyname] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [admin_id, setadmin_id] = useState("");
  const [existingCustomerId, setExistingCustomerId] = useState(null);
  const [rfidWarningModal, setRfidWarningModal] = useState(false);
  const [requiresGarageAccess, setRequiresGarageAccess] = useState(false);
  const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  const access_group_options = [
    { label: "Admin", value: "Admin" },
    { label: "All Access", value: "All Access" },
    { label: "Men's Room", value: "Men's Room" },
    { label: "Women's Room", value: "Women's Room" },
    { label: "Suite 301", value: "Suite 301" },
    { label: "Trash Rm.", value: "Trash Rm." },
    { label: "Apache", value: "Apache" },
    { label: "Caprock", value: "Admin" },
    { label: "Lilly Access", value: "Lilly Access" },
    { label: "McCord", value: "McCord" },
    { label: "Nimble", value: "Nimble" },
    { label: "Hunter", value: "Hunter" },
  ];
  const options = [
    { label: "Rm.307", value: 1 },
    { label: "Rm.308", value: 2 },
    { label: "Rm.309", value: 3 },
    { label: "Rm.310", value: 4 },
    { label: "Rm.311", value: 5 },
    { label: "Rm.312", value: 6 },
    { label: "Rm.313", value: 7 },
    { label: "Rm.314", value: 8 },
    { label: "Rm.315", value: 9 },
    { label: "Rm.316", value: 10 },
    { label: "Rm.317", value: 11 },
    { label: "Rm.318", value: 12 },
    { label: "Rm.319", value: 13 },
    { label: "Rm.320", value: 14 },
    { label: "Rm.321", value: 15 },
    { label: "Rm.322", value: 16 },
    { label: "Rm.323", value: 17 },
    { label: "Rm.324", value: 18 },
    { label: "Rm.325", value: 19 },
    { label: "Rm.326", value: 20 },
    { label: "Rm.327", value: 21 },
    { label: "Rm.328", value: 22 },
    { label: "Rm.333", value: 23 },
    { label: "Rm.335", value: 24 },
    { label: "Rm.336", value: 25 },
    { label: "Rm.337", value: 26 },
    { label: "Rm.338", value: 27 },
    { label: "Rm.339", value: 28 },
    { label: "Rm.340", value: 29 },
    { label: "Rm.342", value: 30 },
    { label: "Rm.343", value: 31 },
    { label: "Rm.344", value: 32 },
    { label: "Rm.345", value: 33 },
    { label: "Rm.346", value: 34 },
    { label: "Rm.347", value: 35 },
    { label: "Rm.348", value: 36 },
    { label: "Rm.350", value: 37 },
    { label: "Rm.351", value: 38 },
    { label: "Rm.352", value: 39 },
    { label: "Rm.353", value: 40 },
    { label: "Rm.354", value: 41 },
    { label: "Rm.355", value: 42 },
    { label: "Rm.356", value: 43 },
    { label: "Rm.357", value: 44 },
    { label: "Rm.358", value: 45 },
    { label: "Rm.359", value: 46 },
    { label: "Rm.360", value: 47 },
    { label: "Rm.361", value: 48 },
    { label: "Rm.362", value: 49 },

  ];
  const [cardId, setcardId] = useState("");
  const [room, setRoom] = useState("");
  const [rfidCheckModal, setrfidCheckModal] = useState(false);

  const [customerId, setcustomerId] = useState(null);
  const [tpCredentialId, settpCredentialId] = useState(null);
  const [tpId, setTpId] = useState(null);
  const [rfidDetails, setRfidDetails] = useState([]);
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [showOverwriteModal, setShowOverwriteModal] = useState(false);
  const [existingEmail, setExistingEmail] = useState("");
  const [showstatus, setshowstatus] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    get(`get_company_list_id`).then((res) => {
      // const data = res;
      setCompanyList(res.data.companies);
      console.log("companyoooooo", res.data.companies);
    });
    var data = JSON.parse(localStorage.getItem("MCData"));
    console.log("ddd", data.company);
    const storedCompany = data.company;
    setCompanyId(data.company);
    setCompanyname(data.companyid);
    if (storedCompany !== 0) {
      setCompanyId_ForPassing(storedCompany);
    }
    var tempadid = data.admin_id;
    setadmin_id(tempadid);
    console.log("admin id is hhy", tempadid);

    let newProfile = "";
    const companyName = data.companyid;

    // Apply custom parking profile logic for admin users
    if (data.company !== 0) {
      // Check if the user is an admin, and update parking profiles accordingly
      if (companyName === "Apache Industrial Services") {
        newProfile = "Level 2";
      } else if (["McCord", "Hunter", "Nimble"].includes(companyName)) {
        newProfile = "Level 3";
      } else {
        newProfile = "Level 4";
      }
      setProfile(newProfile); // Apply the profile for the admin
    }
  }, []);
  const handleEmailChange = (e) => {
    console.log(e.target.value);
    setEmail(e.target.value);
    setEmailError("");
    if (!validateEmail(e.target.value) && e.target.value !== "") {
      setEmailError("Please enter a valid email");
      return;
    }
  };
  const validateName = (name) => {
    const nameRegex = /^[A-Za-z\s]+$/;
    return nameRegex.test(name);
  };

  const validateEmail = (email) => {
    // Email validation logic
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    let month = currentDate.getMonth() + 1;
    let day = currentDate.getDate();
    if (month < 10) {
      month = `0${month}`;
    }
    if (day < 10) {
      day = `0${day}`;
    }
    return `${year}-${month}-${day}`;
  };

  const handleNameChange = (e) => {
    const enteredValue = e.target.value;
    const alphabeticRegex = /^[A-Za-z\s]+$/;
    if (alphabeticRegex.test(enteredValue) || e.target.value === "") {
      setFirstName(enteredValue);
      setFirstNameErr(false);
      console.log();
    } else {
      setFirstNameErr(true);
      // Show tooltip or display an error message
      console.log("Please enter alphabetic characters only");
    }
  };

  const validateMobileNumber = (mobileNumber) => {
    const regex = /^\d{1,10}$/;
    return regex.test(mobileNumber);
  };
  const handleInput = (value) => {
    return value.replace(phoneRegex, "($1) $2-$3");
  };
  function formatPhoneNumber(input) {
    //  if the input is null, return a null value
    if (!input) return input;
    // remove all characters from the input except number input.
    const numberInput = input.replace(/[^\d]/g, "");
    console.log(numberInput);
    //  take the length of the value of the input
    const numberInputLength = numberInput.length;
    console.log(numberInputLength);
    // if the number length is 1, 2, or 3, then return it as it is.
    if (numberInputLength < 4) {
      return numberInput;
    } else if (numberInputLength < 7) {
      // if the number input length is 4, 5, or 6, format it accordingly.
      return `(${numberInput.slice(0, 3)}) ${numberInput.slice(3)}`;
    } else if (numberInputLength >= 7) {
      //  if the number input length is 7, 8, 9, 10, or more, format it like the below.

      return `(${numberInput.slice(0, 3)}) ${numberInput.slice(
        3,
        6,
      )}-${numberInput.slice(6, 10)}`;
    }
    // return empty string in case any condition doesn't satisfy.
    return "";
  }
  const handlemobileChange = (e) => {
    // const enteredValue = e.target.value;
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    //  set the formatted phone number to the input value

    setMobile(formattedPhoneNumber);
  };

  // const handleFacilitycode = (e) =>{

  // };
  const handlefacilityChange = (e) => {
    const newFacilityCode = e.target.value;
    if (newFacilityCode <= 255) {
      setfacilityCode(newFacilityCode);
      const rfidcombined = newFacilityCode.concat(":").concat(cardId);
      setRfid(rfidcombined);
    } else {
      toast.error("Error .. Facillity code must be 0 - 255 range", {
        autoClose: 3000,
      });
    }
  };

  const handleChange = (selected) => {
    console.log(selected);
    // debugger;
    // setItemsnew(selected.map(({ label, index }) => ({ selected: label })));
    setSelectedOptions(selected);
    console.log("Theese aae selecedd ---- > ", selected);
    console.log("-------access ---grp ----->", accessGroup);
  };

  const handleMultiAccessgrp = (selected) => {
    const temp_access_grp = selected;

    if (temp_access_grp.some((option) => option.label !== "Nimble")) {
      setSelectedOptions("");
    }
    setAccessGroup(temp_access_grp);
  };

  const handleAccessGrpChange = (e) => {
    const accessgrp = e.target.value;
    if (accessgrp !== "Nimble") {
      setSelectedOptions("");
    }
    setAccessGroup(accessgrp);
  };

  const handleCardIdChange = (e) => {
    const newCardId = e.target.value;
    if (newCardId <= 65535) {
      setcardId(newCardId);
      const rfidcombined = facilityCode.concat(":").concat(newCardId);
      setRfid(rfidcombined);
    } else {
      toast.error("Error .. Card Id must be 0 - 65535 range", {
        autoClose: 3000,
      });
    }
  };

  const handleCancel = () => {
    navigate("/register");
  };

  const buttonStyle = {
    fontSize: "0.875rem", // Adjust button text size
    padding: "6px 12px", // Adjust button padding for smaller size
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    // padding: '12px 12px',
    borderRadius: "10px",
    bgcolor: "background.paper",
    boxShadow: 24,
  };
  const handleChooseNewRfid = () => {
    console.log("Choosing a new RFID...");
    setrfidCheckModal(false); // Close modal after action
  };

  const handleRfidCheckModalClose = () => {
    setrfidCheckModal(false);
  };
  async function handleSubmit(event) {
    event.preventDefault();
    const isRfidnonEmpty = rfid && rfid.replace(":", "").trim().length > 0;
    const isVehicleZero = vehicle === "0" || vehicle === "";

    // Show popup if if there is an RFID but 0 vehicles
    if (isRfidnonEmpty && isVehicleZero) {
      setRfidWarningModal(true);
      setRequiresGarageAccess(true);
    } else {
      executeSubmit();
    }
  }
  const executeSubmit = async () => {
    console.log("testing level unit 1");

    if (vehicle === "") {
      setVehicle("0");
    }

    if (!validateMobileNumber(mobile)) {
      setMobile("");
    }
    const navi_data = { id: 123, name: "HotelABC" };

    console.log(
      firstName,
      lastName,
      email,
      mobile,
      company,
      profile,
      rfid,
      regdate,
      room,
    );

    const data = {
      firstName,
      lastName,
      email,
      admin_id,
      regdate,
      profile,
      facilitycode: facilityCode,
      cardId,
      vehicles: vehicle,
      company,
      company_id: company_Id_ForPassing,
      building,
      accessgroup: accessGroup,
      mobile,
      rfid,
      room: selectedOptions,
      garage_address: garage,
      requires_garage_access: requiresGarageAccess,
    };

    const datanew = {
      firstName,
      lastName,
      email,
      admin_id,
      regdate,
      profile,
      facilitycode: facilityCode,
      cardId,
      vehicles: vehicle,
      company: companyname,
      company_id: company_Id_ForPassing,
      building,
      accessgroup: accessGroup,
      mobile,
      rfid,
      room: selectedOptions,
      garage_address: garage,
      requires_garage_access: requiresGarageAccess,
    };

    console.log("data == ", data);
    setIsLoading(true);

    try {
      let response;
      if (companyId == 0) {
        response = await post("insert_customerdata", data);
      } else {
        response = await post("insert_customerdata", datanew);
      }

      setIsLoading(false);
      // if (response.status === 200) {
      //     toast.success(response.data.message);

      //     setTimeout(() => {
      //         console.log("Timer finished!");
      //         if (vehicle != 0) {
      //             console.log("redirection happened!", response.data.customer);
      //             navigate("/vehicle", { state: response.data.customer });
      //         } else {
      //             navigate(-1);
      //         }
      //     }, 1000);
      // }
      const vehicleCount = Number(response.data.customer?.vehicles || 0);

      if (vehicleCount > 0) {
        navigate("/vehicle", { state: response.data.customer });
      } else {
        navigate(-1);
      }

      if (response.status === 200) {
        toast.success(response.data.message);
      } else if (
        response.data?.message?.includes(
          "Customer with the same email already exists",
        )
      ) {
        setExistingCustomerId(response.data.customer_id);
        // setExistingEmail(response.data.existing_email);
        // setShowStatus(response.data.status);
        setShowOverwriteModal(true);
      } else {
        toast.error(`Failed to add customer`);
      }
    } catch (error) {
      setIsLoading(false);
      const status = error.response?.status;
      const message = error.response?.data?.message;

      if (status === 409 && message === "Customer already exists in Zero5") {
        toast.error(message, { autoClose: 3000 });
        return;
      }
      if (error.response?.status === 409) {
        console.log("Conflict detected. Fetching RFID details...");
        setIsLoading(true);

        try {
          const { data, status } = await get(
            `fetch_rfiddetails?rfid=${rfid}&email=${email}`,
          );

          if (status === 200) {
            console.log("RFID details fetched:", data);
            setRfidDetails(data); // Store the response data in state
            console.log("rfidDetails :::", rfidDetails);

            setrfidCheckModal(true); // Open modal after successful API call
          } else {
            toast.error("Failed to fetch RFID details");
          }
        } catch (fetchError) {
          setIsLoading(false);
          console.error("Error fetching RFID details:", fetchError);
          toast.error(fetchError.response.data.error, { autoClose: 3000 });
        }

        setIsLoading(false);
      } else if (error.response?.data?.status === "Inactive") {
        // Inactive
        console.log(
          "error.response?.data?.message::",
          error.response?.data?.message,
        );
        setshowstatus(error.response?.data?.status);
        setExistingEmail(error.response?.data?.existing_email);
        setExistingCustomerId(error.response?.data?.customer_id);
        setShowReassignModal(true);
      } else if (
        error.response?.data?.status === null ||
        error.response?.data?.status === "Active"
      ) {
        // Deleted
        console.log(
          "error.response?.data?.message::",
          error.response?.data?.message,
        );
        setshowstatus(error.response?.data?.status || "Active");
        setExistingEmail(error.response?.data?.existing_email);
        setExistingCustomerId(error.response?.data?.customer_id);
        setShowOverwriteModal(true);
      } else {
        toast.error(error.response?.data?.message || "Error occurred", {
          autoClose: 3000,
        });
      }
    }
  };
  console.log("rfid details outside function::", rfidDetails);

  const handleReactivateCustomer = async () => {
    const payload = {
      firstName,
      lastName,
      email,
      admin_id: parseInt(localStorage.getItem("admin_id") || "2"), // or however you're managing login
      regdate,
      profile,
      facilitycode: facilityCode,
      cardId,
      vehicles: vehicle,
      company: companyname,
      company_id: companyId,
      building,
      accessgroup: accessGroup, // assuming same format
      mobile,
      rfid,
      room: "", // if applicable
      garage_address: "707 Redemption", // or dynamic
      customer_id: existingCustomerId,
      action: "reactivate",
    };

    try {
      const response = await post("reactivate_customer", payload);
      if (response.status === 200) {
        toast.success("Customer reactivated successfully");
        navigate(-1);
      } else {
        toast.error("Failed to reactivate customer");
      }
    } catch (error) {
      toast.error("Error reactivating customer");
      console.error(error);
    }
  };

  const handleReassignRfid = async (event) => {
    event.preventDefault();

    try {
      if (
        !rfidDetails?.customer_id ||
        rfidDetails?.tp_credentialid === undefined ||
        !rfidDetails?.tp_id
      ) {
        throw new Error("Missing required RFID details.");
      }

      const payload = {
        customer_id: rfidDetails.customer_id,
        tp_credentialid: rfidDetails.tp_credentialid,
        rfid,
        tp_id: rfidDetails.tp_id,
      };

      console.log("Payload for deletion:", payload);

      const deleteResponse = await remove("delete_rfiddetails", payload);

      if (deleteResponse.status !== 200) {
        throw new Error("Failed to delete RFID details.");
      }

      // RFID successfully deleted, proceed with reassignment
      toast.success("RFID reassigned successfully!");
      setrfidCheckModal(false);
      setRfidDetails({});

      // Handle additional updates
      if (vehicle === "") {
        setVehicle("0");
      }

      if (!validateMobileNumber(mobile)) {
        setMobile("");
      }

      const data = {
        firstName,
        lastName,
        email,
        admin_id,
        regdate,
        profile,
        facilitycode: facilityCode,
        cardId,
        vehicles: vehicle,
        company,
        company_id: company_Id_ForPassing,
        building,
        accessgroup: accessGroup,
        mobile,
        rfid,
        room: selectedOptions,
        garage_address: garage,
      };

      const datanew = {
        ...data,
        company: companyname, // Using `companyname` instead of `company`
      };

      console.log("Data for customer insertion:", data);
      setIsLoading(true);

      try {
        const response =
          companyId === 0
            ? await post("insert_customerdata", data)
            : await post("insert_customerdata", datanew);

        if (response.status === 200) {
          toast.success(response.data.message);
          console.log("count", data.vehicles);
          // setTimeout(() => {
          //   console.log("Timer finished!");
          if (data.vehicles !== "0") {
            console.log("Redirection happened!", response.data.customer);
            navigate("/vehicle", { state: response.data.customer });
          } else {
            navigate(-1);
          }
          // }, 1000);
        } else {
          toast.error("Failed to add customer");
        }
      } catch (error) {
        console.error("Error inserting customer data:", error);
        toast.error("An error occurred while inserting customer data");
      } finally {
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error in reassigning RFID:", error);
      toast.error(
        error.response?.data?.message ||
          "An error occurred while reassigning RFID",
        {
          autoClose: 3000,
        },
      );
    }
  };
  return (
    <React.Fragment>
      <ToastContainer />
      {/* <Navbar name="Dashboard" /> */}
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <div className="col-lg-6 m-auto form-style">
            <h3 className="heading-style">Create Customer</h3>
            <br />
            <hr className="mt-0" />
            <br />
            {isLoading ? (
              <div
                className="table-style"
                style={{ marginLeft: "45%", marginTop: "20%" }}
              >
                <PulseLoader
                  color="#02487B"
                  height={29}
                  margin={4}
                  radius={24}
                  width={4}
                />
                <p style={{ fontWeight: "bold", color: "#02487B" }}>
                  {" "}
                  Please Wait
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <Stack spacing={2} direction="row" sx={{ marginBottom: 2 }}>
                  <Tooltip
                    title="Please enter alphabetic characters only"
                    open={nameErr}
                    placement="left"
                  >
                    <TextField
                      type="text"
                      variant="outlined"
                      color="secondary"
                      label="First Name"
                      onChange={handleNameChange}
                      value={firstName}
                      fullWidth
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Tooltip>
                  <TextField
                    type="text"
                    variant="outlined"
                    color="secondary"
                    label="Last Name"
                    onChange={(e) => setLastName(e.target.value)}
                    value={lastName}
                    fullWidth
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Stack>
                <Tooltip
                  title={emailError}
                  open={Boolean(emailError)}
                  placement="left"
                >
                  <TextField
                    type="email"
                    variant="outlined"
                    color="secondary"
                    label="Email"
                    onChange={handleEmailChange}
                    value={email}
                    fullWidth
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{ mb: 2 }}
                  />
                </Tooltip>
                <TextField
                  type="text"
                  color="secondary"
                  className="mb-3"
                  id="outlined"
                  label="Mobile No"
                  value={mobile}
                  onChange={handlemobileChange}
                  fullWidth
                  sx={{ mb: 2 }}
                  placeholder="(xxx) xxx-xxxx"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <TextField
                  disabled
                  type="date"
                  variant="outlined"
                  color="secondary"
                  label="Registration Date"
                  onChange={(e) => setRegdate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  value={getCurrentDate()}
                  fullWidth
                  // required
                  sx={{ mb: 2 }}
                />
                <br />
                <br /> <br />
                {/* -------- */}
                <TextField
                  // type="text"
                  variant="outlined"
                  color="secondary"
                  label="Parking  Profile"
                  onChange={(e) => setProfile(e.target.value)}
                  value={profile}
                  disabled={companyId !== 0}
                  fullWidth
                  required
                  select
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ native: true }}
                  sx={{ mb: 2 }}
                >
                  <option key="vdsgh65" value="">
                    {" "}
                    Please select{" "}
                  </option>
                  <option key="bt6g5g8" value="All Access">
                    All Access{" "}
                  </option>
                  <option key="lkjyub1" value="Level 1">
                    {" "}
                    Level 1{" "}
                  </option>
                  <option key="lkjyub" value="Level 2">
                    {" "}
                    Level 2{" "}
                  </option>
                  <option key="lkjyub3" value="Level 3">
                    {" "}
                    Level 3{" "}
                  </option>
                  <option key="lkjyub4" value="Level 4">
                    {" "}
                    Level 4{" "}
                  </option>
                  <option key="lkjyub5" value="Level 5">
                    {" "}
                    Level 5{" "}
                  </option>
                  <option key="lkhddb" value="GP">
                    {" "}
                    GP{" "}
                  </option>
                </TextField>
                <TextField
                  type="text"
                  select
                  variant="outlined"
                  color="secondary"
                  label="No Of Vehicles"
                  onChange={(e) => setVehicle(e.target.value)}
                  value={vehicle}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ native: true }}
                  required
                  sx={{ mb: 2 }}
                >
                  <option key="kfdrjh6" value="0">
                    {" "}
                    0{" "}
                  </option>
                  <option key="45dsf4h" value="1">
                    {" "}
                    1{" "}
                  </option>
                  <option key="fghghygh" value="2">
                    {" "}
                    2{" "}
                  </option>
                  <option key="sd4fg7" value="3">
                    {" "}
                    3{" "}
                  </option>
                  {/* <option key="3454fgb" value="4">
                  {" "}
                  4{" "}
                </option> */}
                </TextField>
                <Stack spacing={2} direction="row" sx={{ marginBottom: 2 }}>
                  <TextField
                    type="text"
                    variant="outlined"
                    color="secondary"
                    label="Facility Code"
                    onChange={handlefacilityChange}
                    value={facilityCode}
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    type="text"
                    variant="outlined"
                    color="secondary"
                    label=" Card Id"
                    onChange={handleCardIdChange}
                    value={cardId}
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Stack>
                <TextField
                  type="text"
                  disabled
                  variant="outlined"
                  color="secondary"
                  label="RFID"
                  // onChange={handleNameChange}
                  value={rfid}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <br /> <br /> <br /> <br />
                {companyId === 0 ? (
                  <TextField
                    fullWidth
                    label="Select Company"
                    name="name"
                    // onChange={(e) => setCompany(e.target.value)}
                    onChange={(e) => {
                      const selectedCompany = companyList.find(
                        (company) => company.company_name === e.target.value,
                      );
                      setCompany(selectedCompany.company_name);
                      setCompanyId_ForPassing(selectedCompany.company_id); // Capture company_id as well
                    }}
                    required
                    select
                    value={company}
                    InputLabelProps={{ shrink: true }}
                    SelectProps={{ native: true }}
                    sx={{ mb: 2 }}
                  >
                    <option key="" value="">
                      {" "}
                      Please select{" "}
                    </option>

                    {companyList.map((company) => (
                      <option
                        key={company.company_id}
                        value={company.company_name}
                        selected={
                          localStorage.getItem("company") === company.company_id
                            ? true
                            : false
                        }
                      >
                        {company.company_name}
                      </option>
                    ))}
                  </TextField>
                ) : (
                  <TextField
                    type="text"
                    disabled
                    variant="outlined"
                    color="secondary"
                    label="Company"
                    // onChange={handleNameChange}
                    value={companyname}
                    fullWidth
                    sx={{ mb: 2 }}
                    InputLabelProps={{ shrink: true }}
                    SelectProps={{ native: true }}
                  />
                )}
                <TextField
                  type="text"
                  select
                  variant="outlined"
                  color="secondary"
                  label="Building"
                  // onChange={e => setVehicle(e.target.value)}
                  value={building}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ native: true }}
                  required
                  sx={{ mb: 2 }}
                >
                  <option key="bv" value="1">
                    {" "}
                    250 Assay Street
                  </option>
                </TextField>
                <TextField
                  type="text"
                  select
                  variant="outlined"
                  color="secondary"
                  label="Garage Address"
                  // onChange={e => setVehicle(e.target.value)}
                  value=""
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ native: true }}
                  required
                  sx={{ mb: 2 }}
                >
                  <option key="ga1" value="Garage Address">
                    {" "}
                    707 Redemption
                  </option>
                </TextField>
                <Stack spacing={2} direction="row" sx={{ marginBottom: 2 }}>
                  <div className="dropdown-container">
                    <Select
                      options={access_group_options}
                      placeholder="Select"
                      value={accessGroup}
                      onChange={handleMultiAccessgrp}
                      isSearchable={true}
                      isMulti
                      menuPlacement="top"
                    />
                  </div>

                  {accessGroup.some((option) => option.label === "Nimble") ? (
                    <div className="dropdown-container">
                      <Select
                        options={options}
                        placeholder="Select"
                        value={selectedOptions}
                        onChange={handleChange}
                        isSearchable={true}
                        isMulti
                        menuPlacement="top"
                      />
                    </div>
                  ) : null}

                  {/* ------------------- */}
                </Stack>
                <div className="text-end">
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    size="large"
                    className="me-4 btn-sty"
                  >
                    Save & Continue
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleCancel}
                    size="large"
                    className="btn-sty"
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            )}
          </div>
        </Box>
      </Box>

      <Modal
        open={rfidCheckModal}
        onClose={handleRfidCheckModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              padding: "15px",
              position: "relative",
              width: "100%",
            }}
          >
            <div className="warning-position">
              <img
                src={WarningIcon}
                alt=""
                className=""
                style={{ width: "70px" }}
              />
            </div>

            <IconButton size="small" onClick={handleRfidCheckModalClose}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className="modal-wrapper">
            <div className="important-msg">
              <p>
                This RFID is already Assigned to{" "}
                <b>
                  {" "}
                  {rfidDetails?.first_name} {rfidDetails?.last_name},{" "}
                  {rfidDetails?.email}{" "}
                </b>{" "}
                <br />
                (Status: {rfidDetails?.status})
              </p>
            </div>
            <p
              style={{ color: "#00000080", fontSize: "18px" }}
              className="mt-4"
            >
              Please verify the details before proceeding.
            </p>
            <div className="btn-section-modal">
              <Button
                variant="contained"
                color="primary"
                size="large"
                className="me-4 btn-sty w-100 rfid-btn"
                sx={{ mr: 2, ...buttonStyle }}
                onClick={handleReassignRfid} // Define this function in your component
              >
                Reassign the RFID
              </Button>

              <Button
                variant="outlined"
                color="secondary"
                size="large"
                className="btn-sty w-100 rfid-btn second"
                sx={buttonStyle}
                onClick={handleChooseNewRfid} // Define this function in your component
              >
                Choose a new RFID
              </Button>
            </div>
            <p className="mb-0 notes">
              Note: Reassigning the RFID will delete the RFID record of existing
              user.
            </p>
            <p className="mb-0 notes">
              Choose a new RFID if you want to assign a different RFID to this
              user.
            </p>
          </div>
        </Box>
      </Modal>
      <Modal open={rfidWarningModal} onClose={() => setRfidWarningModal(false)}>
        <Box sx={style}>
          <div style={{ padding: "25px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <img
                src={WarningIcon}
                alt="warning"
                style={{ width: "40px", marginRight: "15px" }}
              />
              <h3 className="heading-style" style={{ margin: 0 }}>
                Garage Access Check
              </h3>
            </div>
            <hr />

            <p style={{ fontSize: "17px", margin: "20px 0" }}>
              {!rfid || rfid === ":"
                ? "No RFID details were provided."
                : "You have assigned an RFID but selected 0 vehicles."}
            </p>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#f5f5f5",
                padding: "15px",
                borderRadius: "8px",
                marginBottom: "25px",
              }}
            >
              <input
                type="checkbox"
                id="garage-check"
                checked={requiresGarageAccess}
                onChange={(e) => setRequiresGarageAccess(e.target.checked)}
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
              />
              <label
                htmlFor="garage-check"
                style={{
                  marginLeft: "12px",
                  cursor: "pointer",
                  fontWeight: "500",
                }}
              >
                Does this customer require garage access?
              </label>
            </div>

            <div className="text-end">
              <Button
                variant="contained"
                color="primary"
                size="large"
                className="me-3 btn-sty"
                onClick={() => {
                  setRfidWarningModal(false);
                  executeSubmit();
                }}
              >
                Confirm & Save
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                className="btn-sty"
                onClick={() => setRfidWarningModal(false)}
              >
                Go Back
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <UserExistCheckModal
        open={showReassignModal}
        onConfirm={handleReactivateCustomer}
        onClose={() => setShowReassignModal(false)}
        onReject={() => {
          setShowReassignModal(false);
          // setEmail("");
        }}
        // onSubmitModal={() => {
        //   // future submit logic goes here
        //   setShowReassignModal(false); // Close modal for now
        // }}
        title="Duplicate Email Found"
        message={`Customer with the same email already exists: ${existingEmail} (${showstatus})`}
        optionA="Reactivate"
        optionB="Choose a new email"
        buttonStyle={buttonStyle}
        style={style}
      />

      <UserExistCheckModal
        open={showOverwriteModal}
        onConfirm={handleReactivateCustomer}
        onClose={() => setShowOverwriteModal(false)}
        // onSubmitModal={() => {
        //   setShowOverwriteModal(false);
        // }}
        onReject={() => {
          setShowOverwriteModal(false);
          // setEmail("");
        }}
        title="Duplicate Email Found"
        message={`Customer with the same email already exists: ${existingEmail} (${showstatus})`}
        optionA="Overwrite"
        optionB="Choose a new email"
        buttonStyle={buttonStyle}
        style={style}
      />
    </React.Fragment>
  );
};

export default RegisterForms;
